export const primaryFont = 'Josefin Sans, sans-serif'
